import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '@/i18n'
import {USER_ROLES} from '@/constants'
import PasswordEmail from "@/components/auth/password/email";
import PasswordReset from "@/components/auth/password/reset";
import Home from '@/components/layout/Home';
import Login from '@/components/auth/login';
import MainWithSidebarWithCache from "@/components/layout/MainWithSidebarWithCache";
import Project from "@/components/projects/Project";
import Projects from "@/components/projects/Projects";
import ProjectOverview from "@/components/projects/ProjectOverview";
import ProjectDisabilities from "@/components/projects/ProjectDisabilities";
import ProjectLogsTab from "@/components/projects/ProjectLogsTab";
import ProjectServices from "@/components/projects/ProjectServices";
import ProjectAvailableService from "@/components/project_services/IndexView";
import ProjectAvailableServiceCreateView from "@/components/project_services/CreateView";
import ProjectElements from "@/components/project_elements/IndexView";
import ProjectElementsCreateView from "@/components/project_elements/CreateView";
import ProjectFoundations from "@/components/project_foundations/IndexView";
import ProjectFoundationsCreateView from "@/components/project_foundations/CreateView";
import ProjectWeather from "@/components/projects/ProjectWeather";
import ProjectAttachments from "@/components/projects/ProjectAttachments";
import ProjectConstructionReport from "@/components/projects/ProjectConstructionReport";
import Issues from "@/components/issues/Issues";
import Issue from "@/components/issues/Issue";
import Component from "@/components/components/Component";
import Floors from "@/components/components/Floors";
import Floor from "@/components/floors/Floor";
import Rooms from "@/components/floors/Rooms";
import Room from "@/components/rooms/Room";
import Walls from "@/components/rooms/Walls";
import Wall from "@/components/walls/Wall";
import Users from "@/components/users/Users"
import User from "@/components/users/User";
import UserOverview from "@/components/users/UserOverview";
import RevisionHistory from "@/components/RevisionHistory";
import Groups from "@/components/groups/Groups";
import Group from "@/components/groups/Group";
import Addresses from "@/components/addresses/Addresses";
import Address from "@/components/addresses/Address";
import Disabilities from "@/components/disabilities/Disabilities";
import Disability from "@/components/disabilities/Disability";
import StaffMembers from "@/components/staff_members/StaffMembers";
import StaffMember from "@/components/staff_members/StaffMember";
import Foundations from "@/components/foundations/Foundations";
import Foundation from "@/components/foundations/Foundation";
import Customers from "@/components/customers/Customers";
import Customer from "@/components/customers/Customer";
import IssuesPage from "@/components/issues/IssuesPage";
import Error from "@/components/errors/Error";
import ProjectPlanning from "@/components/projects/ProjectPlanning";
import ProjectMeasurement from "@/components/projects/ProjectMeasurement";
import ProjectManagement from "@/components/projects/ProjectManagement";
import ProjectAdministration from "@/components/projects/ProjectAdministration";
import BreakHistory from "@/components/users/BreakHistory";
import SidebarItemsList from "@/components/SidebarItemsList";
import Components from "@/components/projects/Components";
import UserLogs from "@/components/users/UserLogs";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            auth: false,
            redirect: '/'
        }
    },

    {
        path: '/password/reset/',
        name: 'password-email',
        component: PasswordEmail
    },
    {
        path: '/password/reset/:token',
        name: 'password-reset',
        component: PasswordReset
    },
    {
        path: '/projects',
        component: MainWithSidebarWithCache,
        meta: {
            auth: true
        },
        props: true,
        children: [
            {
                path: '',
                components: {
                    //                    default: require('@/components/projects/dashboard').default,
                    default: Project,
                    sidebar: Projects
                },
                children: [
                    {
                        path: '',
                        name: 'projects.index',
                        component: ProjectOverview,
                        props: true
                    },
                ]
            },
            {
                path: 'create',
                components: {
                    default: Project,
                    sidebar: Projects
                },
                children: [
                    {
                        path: '',
                        name: 'projects.create',
                        component: ProjectOverview,
                        props: true
                    },
                ]
            },
            {
                path: ':projectId',
                components: {
                    default: Project,
                    sidebar: Components
                },
                props: {
                    default: (route) => ({
                        id: route.params.projectId
                    }),
                    sidebar: true
                },
                children: [
                    {
                        path: '',
                        redirect: {name: 'projects.show'}
                    },
                    {
                        path: 'measurement',
                        component: ProjectMeasurement,
                        props: true,
                        children: [
                            {
                                path: '',
                                name: 'projects.show',
                                component: ProjectOverview,
                                props: (route) => ({id: route.params.projectId}),
                            },
                            {
                                path: 'elements',
                                name: 'projects.elements',
                                component: ProjectElements,
                                props: true,
                                children: [
                                    {
                                        path: 'create',
                                        name: 'projects.elements.create',
                                        component: ProjectElementsCreateView,
                                        props: true,
                                        meta: {
                                            activeTab: 0
                                        }
                                    },
                                    {
                                        path: ':id',
                                        name: 'projects.elements.show',
                                        component: ProjectElementsCreateView,
                                        props: true,
                                    }
                                ]
                            },
                            {
                                path: 'services',
                                name: 'projects.services',
                                component: ProjectAvailableService,
                                props: true,
                                children: [
                                    {
                                        path: ':id',
                                        name: 'projects.services.show',
                                        component: ProjectAvailableServiceCreateView,
                                        props: true,
                                    }
                                ]
                            },
                            {
                                path: 'foundations',
                                name: 'projects.foundations',
                                component: ProjectFoundations,
                                props: true,
                                children: [
                                    {
                                        path: 'create',
                                        name: 'projects.foundations.create',
                                        component: ProjectFoundationsCreateView,
                                        props: true,
                                    },
                                    {
                                        path: ':id',
                                        name: 'projects.foundations.show',
                                        component: ProjectFoundationsCreateView,
                                        props: true,
                                    }
                                ]
                            },
                            {
                                path: 'services-to-complete',
                                name: 'projects.services-to-complete',
                                component: ProjectServices,
                                props: true,
                            },
                        ]
                    },
                    {
                        path: 'planning',
                        name: 'projects.planning',
                        component: ProjectPlanning,
                        props: (route) => ({id: route.params.projectId}),
                    },
                    {
                        path: 'management',
                        component: ProjectManagement,
                        props: true,
                        children: [
                            {
                                path: '',
                                name: 'projects.project-management',
                                redirect: {name: 'projects.project-management.services-to-complete'}
                            },
                            {
                                path: 'services-to-complete',
                                name: 'projects.project-management.services-to-complete',
                                component: ProjectServices,
                                props: true,
                            },
                            {
                                path: 'disabilities',
                                name: 'projects.disabilities',
                                component: ProjectDisabilities,
                                props: true,
                            },
                            {
                                path: 'weather',
                                name: 'projects.weather',
                                component: ProjectWeather,
                                props: true,
                            },
                            {
                                path: 'attachments',
                                name: 'projects.attachments',
                                component: ProjectAttachments,
                                props: true,
                            },
                            {
                                path: 'reports',
                                name: 'projects.reports',
                                component: ProjectConstructionReport,
                                props: true,
                            },
                        ]
                    },
                    {
                        path: 'administration',
                        component: ProjectAdministration,
                        props: true,
                        children: [
                            {
                                path: '',
                                name: 'projects.administration',
                                redirect: {name: 'projects.logs'}
                            },
                            {
                                path: 'logs',
                                name: 'projects.logs',
                                component: ProjectLogsTab,
                                props: true,
                            },
                            {
                                path: 'issues',
                                name: 'projects.issues',
                                component: Issues,
                                props: true,
                            },
                            {
                                path: 'issues/:id',
                                name: 'projects.issues.show',
                                component: Issue,
                                props: true,
                            }
                        ]
                    },
                ]
            },
            //            {
            //                path: ':projectId/new-floor',
            //                name: 'projects.components.floors.create',
            //                components: {
            //                    default: require('@/components/projects/floor').default,
            //                    sidebar: require('@/components/projects/components').default,
            //                },
            //                props: {default: true, sidebar: true},
            //            },
            {
                path: ':projectId/:componentId',
                name: 'projects.components.show',
                components: {
                    default: Component,
                    sidebar: Floors
                },
                props: {
                    default: (route) => ({
                        id: route.params.componentId,
                        projectId: route.params.projectId
                    }),
                    sidebar: true}
            },
            {
                path: ':projectId/:componentId/:floorId',
                name: 'projects.components.floors.show',
                components: {
                    default: Floor,
                    sidebar: Rooms
                },
                props: {
                    default: (route) => ({
                        id: route.params.floorId,
                        componentId: route.params.componentId,
                        projectId: route.params.projectId
                    }),
                    sidebar: true
                }
            },
            {
                path: ':projectId/:componentId/:floorId/:roomId',
                name: 'projects.components.floors.rooms.show',
                components: {
                    default: Room,
                    sidebar: Walls
                },
                props: {
                    default: (route) => ({
                        id: route.params.roomId,
                        floorId: route.params.floorId,
                        componentId: route.params.componentId,
                        projectId: route.params.projectId
                    }),
                    sidebar: true
                }
            },
            {
                path: ':projectId/:componentId/:floorId/:roomId/:wallId',
                name: 'projects.components.floors.rooms.walls.show',
                components: {
                    default: Wall,
                    sidebar: Walls
                },
                props: {
                    default: (route) => ({
                        id: route.params.wallId,
                        roomId: route.params.roomId,
                        floorId: route.params.floorId,
                        componentId: route.params.componentId,
                        projectId: route.params.projectId
                    }),
                    sidebar: true
                }
                ,
                children: []
            },


        ]
    },
    {
        path: '/users',
        component: MainWithSidebarWithCache,
        meta: {
            auth: [USER_ROLES.ADMIN]
        },
        children: [
            {
                path: '',
                name: 'users.index',
                components: {
                    //                    default: require('@/components/users/users_list').default,
                    sidebar: Users
                }
            },
            {
                path: 'create',
                components: {
                    default: User,
                    sidebar: require('@/components/users/Users').default
                },
                children: [
                    {
                        path: '',
                        name: 'users.create',
                        component: UserOverview,
                        props: true
                    },
                ]
            },
            {
                path: ':id',
                components: {
                    default: User,
                    sidebar: Users
                },
                props: {default: true, sidebar: true},
                children: [
                    {
                        path: '',
                        name: 'users.show',
                        component: UserOverview,
                        props: true
                    },
                    {
                        path: 'logs',
                        name: 'users.logs',
                        component: UserLogs,
                        props: true
                    },
                    {
                        path: 'breaks',
                        name: 'users.breaks',
                        component: BreakHistory,
                        meta: {
                            auth: [USER_ROLES.ADMIN]
                        },
                        props: (route) => ({apiUrl: `/api/users/${route.params.id}/breaks`})
                    }
                ]
            }
        ]
    },
    {
        path: '/groups',
        component: MainWithSidebarWithCache,
        meta: {
            auth: [USER_ROLES.ADMIN]
        },
        children: [
            {
                path: '',
                name: 'groups.index',
                components: {
                    //                    default: require('@/components/groups/groups_list').default,
                    sidebar: Groups
                }
            },
            {
                path: 'create',
                name: 'groups.create',
                components: {
                    default: Group,
                    sidebar: Groups
                }
            },
            {
                path: ':id',
                name: 'groups.edit',
                components: {
                    default: Group,
                    sidebar: Groups
                },
                props: {default: true, sidebar: true}
            }
        ]
    },
    {
        path: '/addresses',
        component: MainWithSidebarWithCache,
        meta: {
            auth: [USER_ROLES.ADMIN]
        },
        children: [
            {
                path: '',
                name: 'addresses.index',
                components: {
                    //                    default: require('@/components/addresses/addresses_list').default,
                    sidebar: Addresses
                }
            },
            {
                path: 'create',
                name: 'addresses.create',
                components: {
                    default: Address,
                    sidebar: Addresses
                }
            },
            {
                path: ':id',
                name: 'addresses.show',
                components: {
                    default: Address,
                    sidebar: Addresses
                },
                props: {default: true, sidebar: true}
            }
        ]
    },
    {
        path: '/disabilities',
        component: require('@/components/layout/MainWithSidebarWithCache').default,
        meta: {
            auth: [USER_ROLES.ADMIN]
        },
        children: [
            {
                path: '',
                name: 'disabilities.index',
                components: {
                    //                    default: require('@/components/disabilities/disabilities_list').default,
                    sidebar: Disabilities
                }
            },
            {
                path: 'create',
                name: 'disabilities.create',
                components: {
                    default: Disability,
                    sidebar: Disabilities
                }
            },
            {
                path: ':id',
                name: 'disabilities.show',
                components: {
                    default: Disability,
                    sidebar: Disabilities
                },
                props: {default: true, sidebar: true}
            }
        ]
    },
    {
        path: '/staff_members',
        component: MainWithSidebarWithCache,
        meta: {
            auth: [USER_ROLES.ADMIN]
        },
        children: [
            {
                path: '',
                name: 'staff_members.index',
                components: {
                    sidebar: StaffMembers
                }
            },
            {
                path: 'create',
                name: 'staff_members.create',
                components: {
                    default: StaffMember,
                    sidebar: StaffMembers
                }
            },
            {
                path: ':staffMemberId',
                name: 'staff_members.show',
                components: {
                    default: StaffMember,
                    sidebar: StaffMembers
                },
                props: {default: true, sidebar: true}
            }
        ]
    },
    {
        path: '/foundations',
        component: MainWithSidebarWithCache,
        children: [
            {
                path: '',
                name: 'foundations.index',
                components: {
                    //                    default: require('@/components/users/users_list').default,
                    sidebar: Foundations
                }
            },
            {
                path: 'create',
                name: 'foundations.create',
                components: {
                    default: Foundation,
                    sidebar: Foundations
                }
            },
            {
                path: ':foundationId',
                name: 'foundations.edit',
                components: {
                    default: Foundation,
                    sidebar: Foundations
                },
                props: {default: true, sidebar: true}
            }
        ]
    },
    {
        path: '/customers',
        component: MainWithSidebarWithCache,
        meta: {
            auth: [USER_ROLES.ADMIN]
        },
        children: [
            {
                path: '',
                name: 'customers.index',
                components: {
                    //                    default: require('@/components/users/users_list').default,
                    sidebar: Customers
                }
            },
            {
                path: 'create',
                name: 'customers.create',
                components: {
                    default: Customer,
                    sidebar: Customers
                }
            },
            {
                path: ':customerId',
                name: 'customers.edit',
                components: {
                    default: Customer,
                    sidebar: Customers
                },
                props: {default: true, sidebar: true}
            }
        ]
    },
    {
        path: '/issues',
        name: 'issues',
        component: IssuesPage,
        meta: {
            auth: true
        },
        props: true,
    },
    {
        path: '/issues/:id',
        name: 'issues.show',
        component: Issue,
        meta: {
            auth: true
        },
        props: true
    },
    {
        path: '/404',
        component: Error,
        props: {
            code: 404,
            message: i18n.t('Page not found')
        }
    },
    {
        path: '/403',
        component: Error,
        props: {
            code: 403,
            message: i18n.t('Not allowed')
        }
    },
    {
        path: '*',
        redirect: '/404'
    }
]

const router = new VueRouter({
    mode: 'history',
    routes,
    linkActiveClass: 'active'
})

Vue.router = router;

export default router
